import React, { useState } from "react";
import { useParams } from "react-router";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useProject } from "../../../contexts/project";
import FavouriteReportActions from "../../../views/favoriteReport/FavouriteReportActions";

export default function ReportsMobileView({ favoriteReports, search = "" }) {
  const { clientId } = useParams();
  const currentProject = useProject();
  const currentClientId = clientId || currentProject?.client?.id;
  const [selected, setSelected] = useState(null);

  const filteredReports = search
    ? favoriteReports.filter((report) =>
        (report?.payload?.name || "").toLowerCase().includes(search.toLowerCase())
      )
    : favoriteReports;

  if (favoriteReports.length === 0) {
    return (
      <Box p={4} textAlign="center">
        <Typography variant="body1" color="textSecondary">
          There are no current favorite reports set up
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      {filteredReports.map((row) => (
        <Card
          key={row.id}
          sx={{
            backgroundColor: selected === row.id ? "action.hover" : "background.paper",
          }}
          onClick={() => setSelected(row.id)}
        >
          <CardContent sx={{ "&:last-child": { pb: 2 } }}>
            <Box mb={1.5}>
              <Typography color="text.secondary" fontWeight={500}>
                {row.payload.name}
              </Typography>
            </Box>
            <Box my={1}>
              <Divider />
            </Box>
            <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
              <FavouriteReportActions
                entity={row}
                selectedProjectId={currentProject?.id}
                selectedClientId={currentClientId}
                showSettings={false}
                duplicateLabel="Duplicate and Edit Template"
              />
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}
